import React, { useEffect, useState } from "react";
import AdminDashboard from "@/components/AdminDashboard";
import AdminLogin from "@/components/AdminLogin";
import { api } from "@/lib/api";

export default function AdminPage({ onSettingsSaved }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => setUser(null));
  }, []);

  if (user === undefined) return <main className="admin-gate" data-testid="admin-loading">Loading editor...</main>;
  if (!user) return <AdminLogin onLogin={setUser} />;
  return <AdminDashboard user={user} onLogout={() => { api.post("/auth/logout").finally(() => setUser(null)); }} onSettingsSaved={onSettingsSaved} />;
}
